import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import EqpMonitorMngPage from '../eqpmng/EqpMonitorMngPage';
import ProcessProgressView from './ProcessProgressView';

// 2026-10-11 메뉴 재편: "장비 모니터링"(설비관리 2005) 단독 메뉴가 없어지고,
// "생산 현황" 한 메뉴 밑 [장비 모니터링 | 공정 진행] 탭으로 들어왔다.
// 장비 모니터링 탭은 기존 화면(eqpmng/monitor 라우트의 컴포넌트)을 그대로 그린다.
const ProductionStatusPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'process' ? 'process' : 'monitor';

  const handleChange = (_event, next) => {
    const params = new URLSearchParams(searchParams);
    params.set('tab', next);
    setSearchParams(params);
  };

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
        <Tabs value={tab} onChange={handleChange} aria-label="생산 현황 탭">
          <Tab value="monitor" label="장비 모니터링" />
          <Tab value="process" label="공정 진행" />
        </Tabs>
      </Box>
      {tab === 'process' ? <ProcessProgressView /> : <EqpMonitorMngPage />}
    </Box>
  );
};

export default ProductionStatusPage;
